/**
 * Prefix of the Simulations pages: a top-level menu entry (no group), like the mockup. The router
 * and the paths below both read it from here.
 */
export const SIMULATIONS_BASE = '/simulations'

/** In-app paths of the performance analysis pages, shared by links and redirects. */
export const performanceAnalysisPaths = {
  simulations: {
    list: SIMULATIONS_BASE,
    detail: (uuid: string) => `${SIMULATIONS_BASE}/${uuid}`,
  },
}
